const getLicenseInstances = (state, action) => {
  switch (action.type) {
    case 'GET_LICENSE_INSTANCES_REQUEST_INITIATED':
      return { isFetching: true };
    case 'GET_LICENSE_INSTANCES_REQUEST_SUCCESS':
      return { isFetching: false, data: action.payload };
    case 'GET_LICENSE_INSTANCES_REQUEST_ERROR':
      return { isFetching: false, data: action.payload };
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getLicenseInstances;
